import {
  TextWithAttachmentsConversationMessage,
  ConversationMessageStatus,
  Conversation,
} from '@stripe-internal/conversations-client';
import {FormattedMessage} from 'react-intl';
import {view} from '@sail/ui';
import {messages} from './messages';
import {TextRow} from '../../../Chat';
import {AttachmentRow} from '../../../Chat/Row/AttachmentRow';

type Props = {
  conversation: Conversation;
  message: TextWithAttachmentsConversationMessage;
  avatar?: React.ReactNode | null | undefined;
  TextRowComponent?: React.ComponentType<React.ComponentProps<typeof TextRow>>;
  ChatRowComponent?: React.ComponentProps<
    typeof AttachmentRow
  >['ChatRowComponent'];
  ChatBubbleComponent?: React.ComponentProps<
    typeof AttachmentRow
  >['ChatBubbleComponent'];
};

export const TextWithAttachmentsMessageRow = ({
  conversation,
  message,
  avatar,
  TextRowComponent = TextRow,
  ChatRowComponent,
  ChatBubbleComponent,
}: Props) => {
  const isOwnMessage = message.participant.id === conversation.user.id;
  const position = isOwnMessage ? 'end' : 'start';
  const background = isOwnMessage ? 'neutral600' : 'neutral100';

  const error =
    message.status === ConversationMessageStatus.Error ? (
      <FormattedMessage {...messages.sendError} />
    ) : null;

  return (
    <view.div data-testid="text-with-attachments-message-row">
      {message.text ? (
        <TextRowComponent
          isOwnMessage={isOwnMessage}
          messageId={message.id}
          body={message.text}
          messageType={message.participant.role}
          avatar={avatar}
          position={position}
          background={background}
          error={error}
        />
      ) : null}
      {message.attachments.map((attachment) => {
        return (
          <view.div
            key={`${message.id}-${attachment.name}`}
            css={{marginTop: 'xsmall'}}
          >
            <AttachmentRow
              name={attachment.name}
              size={attachment.size}
              avatar={avatar}
              position={position}
              error={null}
              url={attachment.url}
              ChatRowComponent={ChatRowComponent}
              ChatBubbleComponent={ChatBubbleComponent}
            />
          </view.div>
        );
      })}
    </view.div>
  );
};
